import { createContext } from "react";

export const gameContext = createContext<GameContext | null>(null);

export const { Provider } = gameContext;
